import type { SignUrlRequest, SignUrlResponse } from "@/interfaces/uploads";
import { apiClient } from "@/lib/apiClient";

export async function signUploadUrl(params: SignUrlRequest): Promise<SignUrlResponse> {
  const res = await apiClient.post<SignUrlResponse>("/uploads/sign", params);
  return res.data;
}
